import { decode } from 'base-64'

import { decodeToken } from './decodeToken'

global.atob = decode

export const checkTokenValidity = (token?: string | null) => {
  const tokenPayload = decodeToken(token)
  if (!tokenPayload) return false
  return !tokenPayload.exp || tokenPayload.exp > Date.now() / 1000
}
